//ExpandOnPhone.tsx =================================================
import "../Util/Prototypes";

import * as IdentifyPopup from "./IdentifyPopup";
import * as Settings from "../Settings";
import * as Util from "../Util/Util";
import * as Widgets from "./Widgets";

import { Icon, IconButton } from "@mui/material";

import React from "react";

let expandVisible: boolean = false;
let collapseVisible: boolean = false;
let expandCollapseClicked: boolean = false;

interface iProps {
}

//Render function.
export function Render(props: iProps) {
   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Component did mount.
   React.useEffect(() => {
   }, []);

   //Expand left panel.
   function expandLeftPanel() {
      if (IdentifyPopup.toolVisible) {
         IdentifyPopup.setPosition(true, false);
      } else {
         Widgets.setPosition(true, false);
      }
      expandCollapseClicked = true;
      collapseVisible = true;
      expandVisible = false;
      refresh();
   }

   //Collapse left panel.
   function collapseLeftPanel() {
      if (IdentifyPopup.toolVisible) {
         IdentifyPopup.setPosition(false, true);
      } else {
         Widgets.setPosition(false, true);
      }
      expandCollapseClicked = true;
      expandVisible = true;
      collapseVisible = false;
      refresh();
   }

   //Set visibility for render.
   if (!expandCollapseClicked) {
      const width: number = Util.windowWidth();
      expandVisible = false;
      collapseVisible = false;

      if (width > Settings.smallScreenWidth) {
         collapseVisible = true;

      } else {
         expandVisible = true;
      }
   }

   expandCollapseClicked = false;

   //Render components.
   return (
      <div>
         {expandVisible && Settings.isPhone &&
            <IconButton color="default" onClick={expandLeftPanel} title="Expand to full height" aria-label="Expand" >
               <Icon color="action">expand_less</Icon>
            </IconButton>
         }

         {collapseVisible && Settings.isPhone &&
            <IconButton color="default" onClick={collapseLeftPanel} title="Collapse to half height" aria-label="Collapse">
               <Icon color="action">expand_more</Icon>
            </IconButton>
         }
      </div>
   ); //end return.

} //end function.
